import type { PublishRecord } from './types';

/** TikTok caps pending (unpublished) uploads at 5 per account per 24h. */
export const PENDING_LIMIT = 5;
const WINDOW_MS = 24 * 60 * 60 * 1000;
const PENDING_STATUSES = ['pending', 'processing'];

export function computePendingQuota({
  publishes,
  connectionId,
  now,
}: {
  publishes: PublishRecord[];
  connectionId: string;
  now: Date;
}): { used: number; remaining: number; exceeded: boolean } {
  const cutoff = now.getTime() - WINDOW_MS;
  const used = publishes.filter((p) => {
    if (p.social_connection_id !== connectionId) return false;
    if (!PENDING_STATUSES.includes(p.status)) return false;
    const created = new Date(p.createdAt ?? '').getTime();
    return Number.isFinite(created) && created > cutoff;
  }).length;

  return {
    used,
    remaining: Math.max(0, PENDING_LIMIT - used),
    exceeded: used >= PENDING_LIMIT,
  };
}
